import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0006',
    ecrans: ['00-2'],
    params: ['id', '?pvecleint']
});
